import React from 'react';
import { Link } from 'react-router-dom';
import { fr } from '../i18n/fr';

const LINKS = [
  { to: '/mentions-legales', label: fr.footer_legal_mentions },
  { to: '/cgu', label: fr.footer_legal_cgu },
  { to: '/reglement', label: fr.footer_legal_reglement },
  { to: '/confidentialite', label: fr.footer_legal_confidentialite },
  { to: '/cookies', label: fr.footer_legal_cookies },
  { to: '/contact', label: fr.footer_legal_contact },
];

function Footer() {
  return (
    <footer style={{ borderTop: '1px solid var(--line)', background: 'var(--paper)' }}>
      <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col items-center gap-4 md:flex-row md:justify-between">
        <nav className="flex flex-wrap justify-center gap-x-5 gap-y-2">
          {LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              style={{ fontSize: 12, fontWeight: 600, color: 'var(--muted)' }}
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <p style={{ fontSize: 11, color: 'var(--muted)', margin: 0 }}>
          {fr.footer_rights(new Date().getFullYear())}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
